import { notification } from 'antd';
import { ADD_SURVEY_PARTICIPANTS } from '../../../../../../config/constants';
import constants from './constants';
import { ApiBase } from "../../../../../utils/apiBase";
import { getProjectIdAndOrgId } from '../../../../../utils/apiUtils';

export const surveyWizardAddParticipantToSurvey = (params = {}, callback) => {
    const apiBaseInstance = new ApiBase().instance;
    return dispatch => {
        apiBaseInstance.post(ADD_SURVEY_PARTICIPANTS, { ...params, ...getProjectIdAndOrgId(params) })
            .then(res => updateUsersData(dispatch, res, callback))
            .catch(err => updateUsersDataFailed(dispatch, err, callback));
    };
};

function updateUsersData(dispatch, res, callback) {
    notification.success({ message: constants.updateParticipantDetailsSuccess });
    callback && callback();
}

function updateUsersDataFailed(dispatch, err, callback) {
    let message = constants.updateParticipantDetailsFailed
    if (err && err.response && err.response.data && err.response.data.code && err.response.data.code === "ResourceDuplicate") {
        message = constants.userAlreadyExist
    }
    notification.error({ message: message });
    callback && callback(true);
    return dispatch({ type: '' });
}